import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation, ViewChildren, OnDestroy, Input, SimpleChanges, AfterViewInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { CacheCountryService } from '../../../../services/cacheCountries.service';
import { ApiServicesService } from '../../services/api-services.service';
import { UploadDocumentService } from '../../../../services/upload-document.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ReferenceLibrary } from '../../../../data/models/referenceLibrary.model';
import { ReferenceLibraryService } from '../../../../services/referenceLibrary.service';
import { UtilityServiceService } from '../../services/utility-service.service';
import * as Roles from '../../../../data/constants/roles';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from "@angular/material/table";
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { DependentProfileDataService } from '../../services/dependent-profile-data.service';
import { BeneficiaryQuestionnaireService } from 'src/app/modules/beneficiary-questionnaire/beneficiary-questionnaire.service';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { ActivatedRoute } from '@angular/router';
import { acceptedFileTypes } from 'app-models';

@Component({
  selector: 'app-education-details',
  templateUrl: './education-details.component.html',
  styleUrls: ['./education-details.component.scss']
})
export class EducationDetailsComponent implements OnInit {

  addDegreeCourceForm: FormGroup;
  degreeType: ReferenceLibrary[];
  observableSubscription$ = new Subject();
  listCountry: any[];
  hasID = false;
  listStates: [];
  listCourses: any[] = [];
  beneficiaryId: number;
  familyId: any;
  dependentIdSubscription: Subscription;
  onlyFormBuilder;
  viewMode = false;
  degreeFileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'BENEDUDOC',
    entityId: 0,
    fileCategory: '',
    listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'BENEDUDOC',
    useCase: 'beneficiary',
    useCaseId: 0,
    useEntityId: false,
    isDeleteEnabled: this.viewMode ? false : true,
    isUploadEnabled: this.viewMode ? false : true,
    familyId: null
  };
  displayedColumns: string[] = ['degreeType', 'fieldOfStudy', 'countryName', 'stateName', 'university', 'id'];    
  dataSource : any[] = [];

  constructor(
    private cacheCountryService: CacheCountryService,
    private apiService: ApiServicesService,
    private toastr: ToastrService,
    private changeDetectorRef: ChangeDetectorRef,
    private uploadDocumentService: UploadDocumentService,
    private authenticationService: AuthenticationService,
    private referenceLibraryService: ReferenceLibraryService,
    private utilityService: UtilityServiceService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    protected store: Store<any>,
    private dependentProfileDataService: DependentProfileDataService,
    private benServ: BeneficiaryQuestionnaireService
  ) {
    this.referenceLibraryService.getReferenceDataWithoutAuthentication('DEGR').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ReferenceLibrary[]) => {
      this.degreeType = response;      
    });
    this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = [{ countryCode: '', countryName: 'Select', phoneCode: '' }, ...data.listCountries];
      }
    });
    this.addDegreeCourceForm = this.fb.group({
      id: [],      
      degreetype: [''],
      fieldOfStudy: [''],
      grade: [''],
      universityName: [''],
      addressLine1: [''],
      addressLine2: [''],
      postCode: [''],
      countryCode: [''],
      stateProvinceCode: [null],
      stateProvinceName: [''],
      city: [''],
      startYear: [''],
      endYear: [''],
      degreeAwardedDate: ['']
    });
    //this.listCountry = [];
    this.listStates = [];
   }

   ngOnInit(): void {
    this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
    if(this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : (this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue['beneficiaryId'] : sessionStorage.getItem('beneficiaryId'));
    }
    this.dependentIdSubscription = this.dependentProfileDataService.dependentProfileSubject.subscribe(selectedBeneObj => {      
      this.familyId = selectedBeneObj.dependentId;
    });
    this.getDegreeDetails();

    if (this.beneficiaryId) {
      this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
      this.degreeFileUploadConfigurations.familyId = this.familyId;
      this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
      this.getUpolodedFiles();
    }

  }  

  getUpolodedFiles() {
    this.uploadDocumentService.genericGetUploadDocument(this.degreeFileUploadConfigurations.useCase, this.degreeFileUploadConfigurations.useCaseId, this.degreeFileUploadConfigurations.categoryName, this.degreeFileUploadConfigurations.entityId, this.degreeFileUploadConfigurations.useEntityId, this.degreeFileUploadConfigurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
      if (response['status'] === 200) {
        this.degreeFileUploadConfigurations.listUploadedFiles = response['data'];
        this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
      } else {
        this.degreeFileUploadConfigurations.listUploadedFiles = [];
        this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
      }
      if (response['status'] === 200 || response['status'] === 204) {
        this.getDegreeDetails();
      }
    });

    // console.log("uplosg config",this.degreeFileUploadConfigurations);
  }

  handleCountryChange() {
    const countryCode = this.addDegreeCourceForm.get('countryCode').value;
    this.apiService.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states: []) => {
      this.listStates = states;      
      this.changeDetectorRef.markForCheck();
    });
  }

  getDegreeDetails() {
    this.apiService.getEducationDetails(this.beneficiaryId, this.familyId)
      .pipe(take(1))
      .subscribe(data => {        
        if (data['status'] === 200) {                     
           this.dataSource = data['data']['education'];                        
        }
        if (data['status'] === 204) {
          this.dataSource = [];
        }
      });
  }

  
  saveDegreeDetails(){
    let degreeInfo = this.addDegreeCourceForm.value
    const reqObj = {
      isSaveAsDraft: false,
      id: degreeInfo.id || 0,
      country: {
        countryCode: degreeInfo.countryCode ? degreeInfo.countryCode : ''
      },
      university: degreeInfo.universityName ? degreeInfo.universityName : '',
      degree: degreeInfo.degree ? degreeInfo.degree : '',
      grade: degreeInfo.grade ? degreeInfo.grade : '',
      equivalance: degreeInfo.equivalance ? degreeInfo.equivalance : '',
      fieldOfStudy: degreeInfo.fieldOfStudy ? degreeInfo.fieldOfStudy : '',
      startYear: degreeInfo.startYear ? moment(degreeInfo.startYear).year().toString() : '',
      endYear: degreeInfo.endYear ? moment(degreeInfo.endYear).year().toString() : '',
      degreeAwardedDate: degreeInfo.degreeAwardedDate ? moment(degreeInfo.degreeAwardedDate).format('YYYY-MM-DD') : '',
      addressLine1: degreeInfo.addressLine1 ? degreeInfo.addressLine1 : '',
      addressLine2: degreeInfo.addressLine2 ? degreeInfo.addressLine2 : '',
      stateProvinceCode: degreeInfo.stateProvinceCode ? degreeInfo.stateProvinceCode : null,
      stateProvinceName: degreeInfo.stateProvinceName ? degreeInfo.stateProvinceName : '',
      postCode: degreeInfo.postCode ? degreeInfo.postCode : '',
      city: degreeInfo.city ? degreeInfo.city : '',
      degreeType: {
        id: degreeInfo.degreetype
      },
      courses: this.listCourses
    };

    const reqPayload = { education: [reqObj] };

    this.apiService.saveEducatinDegreeDetails(this.beneficiaryId, reqPayload, this.familyId).pipe(takeUntil(this.observableSubscription$)).pipe(take(1)).subscribe(response => {
      if (response.status === 200) {                
        this.toastr.success(response.message, 'Success');
        response.data['education'].forEach(element => {
          this.degreeFileUploadConfigurations.entityId = element.id;
          this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
          this.listCourses = element.courses;
          this.addDegreeCourceForm.controls['id'].setValue(element.id);     
          this.hasID = true;     
        });
        this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
        //this.resetForm();
        this.getDegreeDetails();        
      } else {
       // this.toastr.error(response.message);
      }
    });

  }

  editEducation(element){
    this.addDegreeCourceForm.patchValue({
      id: element.id ? element.id : 0,
      degree: element.degree ? element.degree : '',
      degreetype: element.degreeType.id,
      fieldOfStudy: element.fieldOfStudy,      
      universityName: element.university,
      addressLine1: element.addressLine1,
      addressLine2: element.addressLine2,
      postCode: element.postCode ? element.postCode : '',
      countryCode: element.country ? element.country.countryCode : null,
      stateProvinceCode: element.stateProvinceCode ? element.stateProvinceCode : null,
      stateProvinceName: element.stateProvinceName,
      city: element.city      
    });
    this.handleCountryChange();    
    if (element.id) {
      this.degreeFileUploadConfigurations.listUploadedFiles = element.documents;
      this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
      this.degreeFileUploadConfigurations.entityId = element.id;
      this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);  
      this.hasID = true;    
    }
  }

  deleteEducation(educationElement){
    const title = 'Confirm';
    const message = 'Do you wish to Delete the File?';
    if (educationElement) {
      this.dialogueInitializer(event, title, message).afterClosed().subscribe(result => {        
        if (result) {
          this.confirmDelete(educationElement);
        }
      })
    }
  }

  dialogueInitializer(event, title: string, message: string) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        buttons: ['Cancel', 'Delete']
      }
    });
    return dialogRef;
  }

  confirmDelete(eduDegree) {    
    this.apiService.deleteEducatinDegreeDetails(this.beneficiaryId, parseInt(eduDegree.id), this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe(data => {      
      this.toastr.success('Deleted successfully!', 'Success');
      this.resetForm();
      this.getDegreeDetails();
    });
  }

  fileUploadSuccess() {
     this.getDegreeDetails();
  }

  resetForm() {
    this.addDegreeCourceForm.reset();
  }

}
